<template>
  <div class="sidebar">
    <b-sidebar
      id="sidebar-backdrop"
      class="sidebar"
      right
      backdrop
      shadow>
      <b-nav class="sidebar__list">
        <b-nav-item class="nav__item" to="/"
                    exact-active-class="active">HOME</b-nav-item>
        <b-nav-item class="nav__item" to="/technology"
                    exact-active-class="active">{{$t('menu.technology')}}</b-nav-item>
        <b-nav-item class="nav__item" to="/product/baby"
                    :class="{ 'product--active': isProduct }"
                    exact-active-class="active">{{$t('menu.products')}}</b-nav-item>
        <div class="nav__product__list">
          <b-nav-item class="nav__item" to="/product/wearable"
                      exact-active-class="active">{{$t('menu.wearable')}}</b-nav-item>
          <b-nav-item class="nav__item" to="/product/baby"
                      exact-active-class="active">{{$t('menu.baby')}}</b-nav-item>
          <b-nav-item class="nav__item" to="/product/bed"
                      exact-active-class="active">{{$t('menu.bed')}}</b-nav-item>
          <b-nav-item class="nav__item" to="/product/golf"
                      exact-active-class="active">{{$t('menu.golf')}}</b-nav-item>
        </div>
        <b-nav-item class="nav__item" to="/about"
                    exact-active-class="active">{{$t('menu.about')}}</b-nav-item>
      </b-nav>

      <!-- ** Change Language Start ** -->
      <div v-if="$i18n.locale() === 'ko'" class="nav__lang no-drag"
           @click="changeLang('en')">{{$t('menu.language.en')}}</div>
      <div v-else class="nav__lang no-drag"
           @click="changeLang('ko')">{{$t('menu.language.kr')}}</div>
      <!-- ** Change Language End ** -->

    </b-sidebar>
  </div>
</template>

<script>
import { checkProductPathMixin } from './mixins/checkProductPath';

export default {
  name: 'Sidebar',
  data() {
    return {
    };
  },
  mixins: [checkProductPathMixin],
  methods: {
    // 언어 설정 변경
    changeLang(langCode) {
      sessionStorage.setItem('langCode', langCode);
      this.$i18n.set(langCode);
      // eslint-disable-next-line no-restricted-globals
      history.go(0);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/constant';
  @import '../assets/scss/mixins';

  /* ------------------
    :: Sidebar Area CSS
    ------------------ */
  .sidebar {
    &__list {
      @include inline-flex;
      @include flex-direction(column);
      font-size: 20px;

      .nav-link {
        margin-top: 20px;
        padding: 10px 0;
        cursor: pointer;
        color: $color-light-gray;

        &.active {
          color: $color-header-gray;
        }
        &:hover {
          color: $color-header-gray;
        }
      }
    }
  }
  .nav__lang {
    line-height: 27px;
    width: 80px;
    height: 29px;
    border: solid 1px $color-light-gray;
    cursor: pointer;
    margin: 30px auto;
    color: $color-light-gray;
    &:hover {
      border: solid 1px $color-header-gray;
      color: $color-header-gray;
    }
  }

  // Product 하위 메뉴
  .nav__product__list {
    font-size: 15px;
    .nav-link {
      margin-top: 0;
    }
  }
  // product nav active Start
  .product--active {
    .nav-link {
      color: $color-header-gray!important;
    }
  }
  // product nav active End

  /deep/
  .b-sidebar-body {
    text-align: center;
  }
  /deep/
  .close {
    & > svg {
      width: 40px;
      height: 40px;
    }
  }
  // IE Only
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /deep/
    .b-sidebar-outer {
      z-index: 9999;
    }
  }
</style>
